import _, {isEqual, omit} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CalendarEventVersionModel} from '../../../models/api/calendarEventVersionModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {CalendarEventVersionActionsEnum} from '../calendarEventVersions/calendarEventVersionsActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';

/*
 * Reducer.
 */

const calendarEventVersionsUpdatedReducer = createResourcesUpdatedReducer(
  'calendarEventVersions',
  (calendarEventVersion) => calendarEventVersion.uid,
  mergeCalendarEventVersion,
);

export function calendarEventVersionsReducer(
  state: ResourceMap<CalendarEventVersionModel>,
  action: AppAction,
): ResourceMap<CalendarEventVersionModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return calendarEventVersionsUpdatedReducer(state, action);

    case CalendarEventVersionActionsEnum.CALENDAR_EVENT_VERSION_DELETED:
      return omit(state, action.payload);

    default:
      return state;
  }
}

/*
 * Merger.
 */

function mergeCalendarEventVersion(
  existingCalendarEventVersion: CalendarEventVersionModel | undefined,
  updatedCalendarEventVersion: CalendarEventVersionModel,
): CalendarEventVersionModel {
  // If no existing event found, nothing to merge.
  if (!existingCalendarEventVersion) {
    return updatedCalendarEventVersion;
  }

  // If the event versions are equal, don't do an identity change.
  if (isEqual(existingCalendarEventVersion, updatedCalendarEventVersion)) {
    return existingCalendarEventVersion;
  }

  // Merge the calendarVersion IDs.
  return {
    ...updatedCalendarEventVersion,
    calendarVersionIds: _(existingCalendarEventVersion.calendarVersionIds)
      .concat(updatedCalendarEventVersion.calendarVersionIds)
      .uniq()
      .value(),
  };
}
